<template>
  <div id="app">
    <div class="page">
       <div class="page-head">
        <div class="page-head-left"><img src="./img/jsuanqi.png" /></div>
        <!-- <div class="page-head-right"> <span>智能计算器</span></div> -->
    </div>
      <div class="page-login">
        <div class="page-from">
          <div class="login-div">
            <input
              type="text"
              name="mobile"
              oninput="if(value.length>11)value=value.slice(0,11)"
              v-model="from.mobile"
              class="login-input"
              placeholder="请输入手机号"
              @keyup="setLoginData()"
            />
          </div>
          <div class="login-input-mar login-div">
            <input
              type="text"
              name="password"
              oninput="if(value.length>5)value=value.slice(0,5)"
              v-model="from.code"
              class="login-input"
              placeholder="请输入验证码"
              @keyup="toLogin()"
            />
            <button id="sendCode" :disabled="btnDisabled" @click="sendCode">{{ btnText }}</button>
          </div>

          <div class="login-input-img login-div">
            <div class="agree-img" @click="changeImg">
              <img :src="imgFlag == false ? unimgSrc : imgSrc" alt />
            </div>

            <div class="agree-text">
              我已阅读并且同意
              <a @click="goRegistAgree">《注册协议》</a>
              <a @click="goPrivacyAgree">《隐私协议》</a>
            </div>
          </div>

          <div class="login-button">
            <button @click="loginCode">立即登录</button>
          </div>
        </div>
      </div>
      <div class="page-foot">
        <!-- <div class="t2">
          Copyright © 2020 
          <br />深圳市无间数码科技有限公司
        </div> -->
      </div>
    </div>

    <div class="tan" :class="{tanhide:codeshow}">
      <div class="tan-head">
        <img :src="closeSrc" @click="closeTan" />
      </div>
      <div class="tan-page">
        <div class="tan-page-text">请输入图形验证码</div>
        <div class="tan-page-code">
          <div class="tan-page-code-img" @click="getCode">
            <img :src="codeimg" alt />
          </div>
          <div class="tan-page-code-input">
            <input
              type="text"
              v-model="tuicode"
              oninput="if(value.length>4)value=value.slice(0,4)"
              placeholder="请输入验证码"
              @keydown="handleinput2"
            />
          </div>
        </div>
      </div>
      <div class="tan-foot" @click="sendCode">
        <span>确认</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:codeshow}"></div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  name: "app",
  metaInfo: {
    title:"好运吧",
  },
  data() {
    return {
      msg: "渠道推广",
      btnText: "发送验证码",
      from: {
        mobile: "",
        code: "",
        shareType: 1,
        shareId: null
      },
      unimgSrc: require("./img/login-disagree.png"),
      imgSrc: require("./img/loggin-agree.png"),
      closeSrc: require("../../assets/img/close@2x.png"),
      imgFlag: true,
      codeshow: true,
      btnDisabled: false,
      btnDisabled: false,
      tuicode: "",
      codeimg: "",
      cid: ""
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var channelId = this.$route.params.channelId;
    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);
    this.cid = channelId;
  
  },

  methods: {
    handleinput2(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
      console.log(e.target.value.replace(/[^\d]/g, ""));
    },
    goRegistAgree: function() {
      this.$router.push("/agree/register");
    },
    goPrivacyAgree: function() {
      this.$router.push("/agree/privacyAgree");
    },
    closeTan: function() {
      this.codeshow = true;
    },
    setLoginData() {
      var mobile = this.from.mobile;
      var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;

      if (strTemp.test(mobile)) {
        this.sendCode();
      }
    },
    toLogin() {
      var code = this.from.code;
      var numReg = /^[0-9]*$/;
      if (numReg.test(code) && code.length == 4) {
        this.loginCode();
      }
    },
    getCode: function() {
      let This = this;

      this.$axiosHttp({
        method: "POST",
        url: api.qml.getCode,
        data: this.from
      })
        .then(res => {
          //console.log("获取图形验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            this.codeimg = res.result;
            this.codeshow = false;
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    },
    downapp() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // 是微信端
        this.copyshow = false;
        return;
      } else {
        if (/(Android)/i.test(navigator.userAgent)) {
          //下载
          window.location.href = "http://calc.haoyunba.com/apk/" + this.channel;
          this.$point.eventuid(
            "down_app_" + this.channel,
            this.userid,
            "down_app"
          );
        } else {
          this.codeshow = false;
        }
      }
    },
    loginCode: function() {
      this.$point.eventId("btn_100003");

      var mobile = this.from.mobile;
      if (mobile == null || mobile == "") {
        tips.toast("请输入手机号码");
        this.$point.eventId("btn_100006");

        return false;
      }
      if (!util.isPhone(this.from.mobile)) {
        tips.toast("请填写正确的手机号!");
        this.$point.eventId("btn_100006");

        return false;
      }
      var code = this.from.code;
      if (code == null || code == "") {
        tips.toast("请输入验证码");
        this.$point.eventId("btn_100006");

        return false;
      }
      if (this.imgFlag == false) {
        tips.toast("请勾选协议");
        this.$point.eventId("btn_100006");

        return false;
      }

      this.$axiosHttp({
        method: "POST",
        url: api.qml.login,
        data: this.from
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            //console.log(JSON.stringify( res.result));
            console.log(JSON.stringify(res.result.userRelList[0].code));
            //将对应的数据保存到Vuex中
            // store.commit(types.SET_USERINFO, res.result);
            // store.commit(types.SET_TOKEN_SCOKET, res.result.socketToken);

            // store.commit(types.SET_USERLIST, res.result.userRelList);
            // store.commit(types.LOGIN, res.result.usertoken);

            // store.commit(types.SET_CODE, res.result.userRelList[0].code);
            //用户打开首页链接后，用户访问的渠道将设置为官网
            // store.commit(types.SET_CHANNEL, res.result.channelid);
            // console.log(
            //   "store里面的getChannel有值" + JSON.stringify(this.getChannel)
            // );
            localStorage.setItem("token", res.result.usertoken);

            //登录成功
            var registerFlag = 2;
            if (res.result.registerFlag) {
              registerFlag = res.result.registerFlag;
            }

            this.$router.push({
              name: "downapp",
              params: {
                userid: res.result.id,
                cid: this.cid,
                registerFlag: registerFlag
              }
            });
            // _ks_trace.push({
            //   event: "form",
            //   convertId: 38910,
            //   cb: function() {
            //     console.log("快手用户注册成功");
            //   }
            // });
            if(res.result.registerFlag == 1){
               _ks_trace.push({
                event: "form",
                convertId: 38910,
                cb: function() {
                  console.log("注册成功");
                }
              });
            }
             

            this.$point.eventId("btn_100004");
          } else {
            tips.toast(res.message);
            this.$point.eventId("btn_100005");
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
          this.$point.eventId("btn_100005");
        });
    },
    changeImg: function() {
      if (this.imgFlag == true) {
        this.imgFlag = false;
      } else {
        this.imgFlag = true;
      }
    },
    sendCode: function() {
      var mobile = this.from.mobile;
      if (mobile == null || mobile == "") {
        tips.toast("请输入手机号");
        return false;
      }

      var data = {
        mobile: this.from.mobile,
        type: 1,
        code: this.tuicode
      };
      let This = this;

      this.$axiosHttp({
        method: "POST",
        url: api.qml.sendCodeEx,
        data: data
      })
        .then(res => {
          //console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            tips.toast("发送成功");
            this.codeshow = true;
            this.getSecond(60);
          } else if (res.code == 1402) {
            this.opentTan();
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    },
    opentTan: function() {
      var mobile = this.from.mobile;
      if (mobile == null || mobile == "") {
        tips.toast("请输入手机号码");
        return false;
      }
      if (!util.isPhone(this.from.mobile)) {
        tips.toast("请填写正确的手机号!");
        return false;
      }
      var flag = this.getCode();
      console.log("获取" + flag);
    },
    //发送验证码
    getSecond(wait) {
      let _this = this;
      let _wait = wait;
      if (wait == 0) {
        this.btnDisabled = false;
        this.btnText = "重新获取";
        wait = _wait;
      } else {
        this.btnDisabled = true;
        this.btnText = "" + wait + "s";
        wait--;
        setTimeout(function() {
          _this.getSecond(wait);
        }, 1000);
      }
    }
  },
  watch: {
    from: {
      handler(val, oldVal) {
        console.log("from: " + JSON.stringify(val));
        val.mobile = val.mobile.replace(/[^\d]/g, "");
        val.code = val.code.replace(/[^\d]/g, "");
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          val.code = val.code.substring(0, 4);
        } else {
        }

        var code = this.from.code;
        var numReg = /^[0-9]*$/;
        if (numReg.test(code) && code.length == 4) {
            //this.loginCode();
        }
      },
      deep: true //true 深度监听
    },
    tuicode: {
      handler(val, oldVal) {
        console.log("tuicode: " + JSON.stringify(val));
        this.tuicode = val.replace(/[^\d]/g, "");
      },
      deep: true //true 深度监听
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1737px;
  background: rgba(55, 148, 212, 1);
}
.page-login {
  background: url("./img/bk-01.png");
  background-size: 100% 100%;
  width: 750px;
  height: 1435px;
}
.page-from {
  height: 338px;
  margin: 605px auto 0px auto;
  position: absolute;
}
.login-div {
  width: 632px;
  margin: 10px 50px 0px;
}

.page-from input {
  width: 551px;
  height: 39px;
  background: rgba(0, 10, 35, 1);
  border-radius: 8px;
  border: none;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(46, 66, 116, 1);
  line-height: 79px;
  margin-top: 5px;
}

.login-input {
  width: 632px;
  height: 46px;
  background: rgba(19, 19, 37, 1);
  border: 1px solid rgb(3, 3, 32);
  border-radius: 16px;
  color: rgba(46, 66, 116, 0.5);
  padding: 30px 20px 20px 22px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(46, 66, 116, 0.5);
  line-height: 40px;
}

.login-input input::-webkit-input-placeholder {
  width: 100%;
  height: 40px;
  background: rgba(19, 19, 37, 1);
  border-radius: 16px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(46, 66, 116, 0.5);
  line-height: 40px;
  position: relative;
  left: 20px;
}
.login-input-img {
  margin-top: 20px;
}

.login-code {
  margin-top: 20px;
}

.page-foot {
  background: url("./img/back-2@2x.png");
  background-size: 100% 100%;
  width: 750px;
  height: 1789px;
}

#sendCode {
  display: block;
  position: absolute;
  width: 200px;
  height: 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(19, 101, 231, 1);
  line-height: 40px;
  float: right;
  margin: -82px 0px 0px 400px;
  border: none;
  text-align: right;
  background: rgba(0, 10, 35, 0);
}

.agree-img {
  width: 28px;
  height: 28px;
  border-radius: 16px;
  margin: 3px 28px 0px 10px;
  position: relative;
  float: left;
}
.agree-img img {
  width: 28px;
  height: 28px;
  position: absolute;
}

.agree-text {
  height: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(46, 66, 116, 1);
  line-height: 48px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 34px;
  position: relative;
  float: left;
  text-align: left;
}

.page-from input {
  color: white;
  font-size: 28px;
}

.login-button {
  width: 590px;
  height: 79px;
  margin: 40px auto 0;
}

.login-button button {
  width: 590px;
  height: 79px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(28, 97, 235, 1) 100%
  );
  border-radius: 50px;
  border: none;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  margin-top: 20px;
}

.login-button button:active {
  background: rgba(175, 199, 255, 1);
}

.tan {
  position: fixed;
  z-index: 9999;
  top: 428px;
  margin: 0 auto;
  position: fixed;
  width: 540px;
  height: 370px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 0px 104px 0px 106px;
  z-index: 99999;
}

.tan-back {
  position: fixed;
  z-index: 99998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}

.tan-head {
  width: 100%;
  height: 50px;
}
.tan-head img {
  position: relative;
  width: 32px;
  height: 32px;
  float: right;
  margin: 16px 20px 0 0;
}
.tan-page {
  width: 100%;
  height: 240px;
}
.tan-foot {
  width: 540px;
  height: 102px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(56, 48, 234, 1) 100%
  );
  border-radius: 0px 0px 16px 16px;
}

.tan-foot span {
  width: 240px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 100px;
}

.tan-page-text {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 38px;
  padding: 20px 0 0 0;
}
.tan-page-code {
  width: 476px;
  height: 100px;
  padding: 30px 0 0 32px;
}
.tan-page-code div {
  float: left;
}

.tan-page-code-img {
  width: 190px;
  height: 92px;
  border-radius: 61px;
}

.tan-page-code-img img {
  width: 190px;
  height: 92px;
}

.tan-page-code-input {
  width: 272px;
  height: 92px;
  margin: 0 0 0 14px;
}
.tan-page-code-input input {
  width: 202px;
  height: 61px;
  background: rgba(247, 247, 247, 1);
  border-radius: 61px;
  border: none;
  padding: 15px 35px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  text-align: center;
}

.tan-page-code-input input::-webkit-input-placeholder {
  position: relative;
  left: 20px;
  width: 172px;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  margin-left: -10px;
}
.tanhide {
  display: none;
}

.t2 {
  position: relative;
  bottom: -1204px;
  color: wheat;
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC;
}

.page-head {
  width: 300px;
  height: 53px;
  margin: 14px 0 0 12px;
  position: absolute;
}
.page-head-left{
  height: 100px;
  float: left;
}
.page-head-right{
  height: 100px;
  float: left;
  margin-left: 10px;
}
.page-head .page-head-left img {
  width: 53px;
  height: 53px;
  border-radius: 4px;

}
.page-head .page-head-right span {
  height: 17px;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(246, 202, 155, 1);
  line-height: 53px;
}
</style>


// WEBPACK FOOTER //
// src/components/channel/channelHybks.vue